import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpStatusIcon, CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
export const CyclecountSummaryTblCard = ({ data = [], onClick = () => { } }) => {
  return (

    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} sm={6} md={6} key={index} onClick={() => {
          let items = { row: item };
          onClick(items);
        }}>
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Sheet No
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.A_SheetId}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Location
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.LocName}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Bin Name
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.BinName}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Date
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {moment(item.A_Date).format('DD/MM/YYYY')}
                </Typography>
              </Grid>


              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Status
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  <CmpStatusIcon xStatus={item?.A_Status} />
                </Typography>
              </Grid>

              {/* 
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Reference No
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  <CmpStatusIcon xStatus={item?.A_RefNo} />
                </Typography>
              </Grid> */}

            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
